<div class="column">
    <h2>Rettocolite ulcerosa - Pazienti stabili e instabili per durata malattia</h2>
    <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
      <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas id = "myChartStableUnstableUCDuration"></canvas>
      </div>
    </div>
  </div>